module.exports = __webpack_public_path__ + "/img/ChipArray-4side-FlatConcave-Labeled-HoJFG4.svg";